import {useMemo} from "react";
import type {CatalogFilterGroup} from "@zaaaz/shared";
import {useI18n} from "./I18nProvider";

type Props = {
  filters: Record<string, number[]>;
  pretMin?: number;
  pretMax?: number;
  groups: CatalogFilterGroup[];
  hideBrandFilter?: boolean;
  onRemoveFacet: (fid: number, oid: number) => void;
  onRemovePriceRange: () => void;
};

export function ProductActiveFilters({filters, pretMin, pretMax, groups, hideBrandFilter, onRemoveFacet, onRemovePriceRange}: Props) {
  const {t} = useI18n();
  const visibleGroups = useMemo(() => groups.filter((g) => !(hideBrandFilter && g.isBrand)), [groups, hideBrandFilter]);
  const chips = useMemo(() => {
    const out: {key: string; group: string; label: string; onRemove: () => void}[] = [];
    for(const [fidStr, oids] of Object.entries(filters)) {
      const fid = Number(fidStr);
      if(!fid || !oids?.length) continue;
      const g = visibleGroups.find((x) => x.id === fid);
      if(hideBrandFilter && g?.isBrand) continue;
      const groupName = g?.nume ?? t("Filter");
      for(const oid of oids) {
        const opt = g?.options.find((o) => o.id === oid);
        out.push({
          key: `f-${fid}-${oid}`,
          group: groupName,
          label: opt?.nume ?? String(oid),
          onRemove: () => onRemoveFacet(fid, oid)
        });
      }
    }
    if(pretMin !== undefined || pretMax !== undefined) {
      let label = "";
      if(pretMin !== undefined && pretMax !== undefined) label = `${pretMin} – ${pretMax} Lei`;
      else if(pretMin !== undefined) label = `≥ ${pretMin} Lei`;
      else label = `≤ ${pretMax} Lei`;
      out.push({
        key: "range",
        group: t("PRICE"),
        label,
        onRemove: onRemovePriceRange
      });
    }
    return out;
  }, [filters, pretMin, pretMax, visibleGroups, onRemoveFacet, onRemovePriceRange, t]);
  if(!chips.length) return null;
  return (
    <div className="cc-activeFilters">
      {chips.map((c) => (
        <button key={c.key} type="button" className="cc-activeFilters__chip" onClick={c.onRemove}>
          <i className="fa fa-times" aria-hidden="true" />
          <b>{c.group}</b>
          <span>{c.label}</span>
        </button>
      ))}
    </div>
  );
}
